export const typeOptions = [
  {
    value: "crédito",
    label: "Crédito"
  },
  {
    value: "fidelidade",
    label: "Fidelidade"
  }
];

export const productOptions = [
  {
    value: "1",
    label: "Crédito em Loja - 3x Sem Juros"
  },
  {
    value: "2",
    label: "Crédito em Loja - 6x Sem Juros"
  },
  {
    value: "3",
    label: "Crédito em Loja - 12x Sem Juros"
  },
  {
    value: "4",
    label: "Crédito em Loja - 24x Com Juros"
  },
  {
    value: "5",
    label: "Cartão de Crédito - Visa"
  },
  {
    value: "6",
    label: "Cartão de Crédito - MasterCard"
  },
  {
    value: "7",
    label: "Cartão de Crédito - American Express"
  },
  {
    value: "8",
    label: "Cartão de Crédito - Diners Club"
  },
  {
    value: "9",
    label: "Cartão de Crédito - Elo"
  },
  {
    value: "10",
    label: "Cartão de Crédito - 3x Sem Juros"
  },
  {
    value: "11",
    label: "Cartão de Crédito - 6x Sem Juros"
  },
  {
    value: "12",
    label: "Cartão de Crédito - 12x Com Juros"
  }
];

export const servicePointOptions = [
  {
    value: "1",
    label: "Lojas Ferreira - Unidade Campinas",
    subLabel: "Matriz"
  },
  {
    value: "2",
    label: "Lojas Fernandes - Unidade São Paulo",
    subLabel: "Filial"
  },
  {
    value: "3",
    label: "Loja Marcelo - Unidade Rio de Janeiro",
    subLabel: "Filial"
  }
];
